
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5892|6787|9067)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
